import { createIndexedLocalStore } from '../../../utilities/localStorage-store';

const editorlocalstore = createIndexedLocalStore({
    keyPrefix: 'grapesjs-autosave:',
    indexKey: 'grapesjs-autosave:index',
    defaultMaxAgeMs: 4 * 60 * 60 * 1000,
    defaultMaxEntries: 3,
    composeKey: (modelId, referenceId) => `${modelId}:${referenceId}`,
    createEntry: ({ keyParts, data, savedAt }) => {
        const [modelId, referenceId] = keyParts;
        return { data, savedAt, modelId, referenceId };
    },
});

export default editorlocalstore;